import { Component, OnInit } from '@angular/core';
import { FirestoreService } from '../../services/firestore/firestore.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-reporte-seguridad',
  templateUrl: './reporte-seguridad.component.html',
  styleUrls: ['./reporte-seguridad.component.css']
})
export class ReporteSeguridadComponent implements OnInit {
  public servicios = [];

  constructor(private firestoreService: FirestoreService) { }

  ngOnInit(): void {

  }

  getServices() {
    this.firestoreService.getSecurityList().snapshotChanges().pipe(
      map(changes =>
        changes.map(c =>
          ({ key: c.payload.doc.id, ...c.payload.doc.data() })
        )
      )
    ).subscribe(departaments => {
      this.servicios = departaments;
      console.log(departaments);
    });
  }

  delete(key) {
    this.firestoreService
      .deleteSecurity(key)
      .catch(err => console.log(err));
  }

  update(key, data) {
    if (data.status)
      data.status = false;
    else
      data.status = true;
    this.firestoreService
      .updateSecurity(key, data)
      .catch(err => console.log(err));
  }

}
